import React, { useState } from "react";
import "./Faq.css";

const Faq = () => {
  const [activeFaq, setActiveFaq] = useState(null);
  const faq = [
    {
      question: "What is HyperPay?",
      answer:
        "HyperPay is a cutting-edge payment solution designed to easily integrate cryptocurrency payments into your digital business. It allows developers to add crypto payment functionality to their platform using our npm package, simplifying the process for both the business and the customer.",
    },
    {
      question: "How does HyperPay work?",
      answer:
        "HyperPay works by installing our npm package into your platform. You’ll need to register your company’s MetaMask address on our admin page. Once that's done, simply pass that address to the payment module as a prop, and HyperPay handles the rest, processing crypto payments directly on your platform.",
    },
    {
      question: "Which cryptocurrencies are supported by HyperPay?",
      answer:
        "HyperPay supports a wide range of popular cryptocurrencies, including Bitcoin (BTC), Ethereum (ETH), and various ERC-20 tokens. We continuously update our platform to include more currencies as the crypto landscape evolves.",
    },
    {
      question: "Is HyperPay secure?",
      answer:
        "Absolutely. HyperPay uses industry-standard encryption and follows best practices to ensure that all transactions are secure. By leveraging the security of blockchain technology and MetaMask, we provide a safe environment for crypto transactions.",
    },
    {
      question: "Can I use HyperPay in my country?",
      answer:
        "HyperPay offers direct crypto payments, which are not allowed in many countries. Before integrating HyperPay, please check your local regulations to ensure compliance with crypto payment laws in your country.",
    },
    {
      question: "What are the fees associated with using HyperPay?",
      answer:
        "HyperPay charges a small transaction fee for each payment processed through our platform. The exact fee depends on the cryptocurrency used and the transaction amount. Detailed fee information can be found on our pricing page.",
    },
    {
      question: "How do I get started with HyperPay?",
      answer:
        "To get started, you need to install the HyperPay npm package on your platform. After that, register your MetaMask address on our admin page and integrate the payment module into your system. For detailed instructions, visit our developer documentation.",
    },
    {
      question: "What kind of support does HyperPay offer?",
      answer:
        "HyperPay offers 24/7 customer support via email and chat. We also have extensive documentation, tutorials, and a community forum where you can ask questions and share experiences with other HyperPay users.",
    },
    {
      question: "What happens if a payment fails?",
      answer:
        "If a payment fails, the transaction is automatically rolled back, and no funds are transferred. Both you and the customer will be notified, and you can attempt the payment again. Our support team is also available to assist with any issues.",
    },
    {
      question: "Can I customize the payment process?",
      answer:
        "Yes, HyperPay is highly customizable. You can tailor the payment flow to match your brand and user experience. Our developer documentation provides guidelines on how to customize different aspects of the payment process.",
    },
  ];

  let openFaq = (index) => {
    if (index !== activeFaq) {
      setActiveFaq(index);
    } else {
      setActiveFaq(null);
    }
  };
  return (
    <div className="landingFaqContent">
      <div className="faqElementMainTtlCont fade-up">
        <h1 className="faqElementMainTtl">Frequently Asked Questions</h1>
      </div>
      <div className="faqElements fade-up">
        {faq.map((item, index) => {
          return (
            <div
              className={`faqElement ${activeFaq == index ? "active" : ""}`}
              onClick={() => {
                openFaq(index);
              }}
              key={index}
            >
              <div className="ttl faqElementTtl">{item.question}</div>
              <div className="faqElementAnswer">{item.answer}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Faq;
